<script>
export default {
  name: "AlIceCream",
  data() {
    return {
      iceCreams: [
        {
          name: "Çokollatë",
          priceS: "kornet 40 den.",
          priceL: "një gotë të vogël 50 den.",
          priceXL: "një gotë e madhe 70 den."
        },
        {
          name: "Vaniljе",
          priceS: "kornet 40 den.",
          priceL: "një gotë të vogël 50 den.",
          priceXL: "një gotë e madhe 70 den."
        },
        {
          name: "Dredhëze",
          priceS: "kornet 40 den.",
          priceL: "një gotë të vogël 50 den.",
          priceXL: "një gotë e madhe 70 den."
        },
        {
          name: "Përzíer",
          priceS: "kornet 40 den.",
          priceL: "një gotë të vogël 50 den.",
          priceXL: "një gotë e madhe 70 den."
        },
      ],
    };
  },
}
</script>

<template>
<div class="main">
  <base-card v-for="iceCream in iceCreams" :key="iceCream.name">
    <v-card-title>{{ iceCream.name }}</v-card-title>
    <v-card-text>{{ iceCream.text }}</v-card-text>
    <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ iceCream.priceS }} <br />
        {{ iceCream.priceL }} <br />
        {{ iceCream.priceXL }}
    </v-card-actions>
  </base-card>
</div>
</template>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>